import { lazy } from "react";

export enum RouteEnum {
  WEALTH = "/wealth",
  DASHBOARD = "/dashboard",
  HOUSE = "/house",
  SETTINGS = "/settings",
  CHANGELOG = "/changelog",
}

const delayed = (compImport: any) =>
  new Promise<any>((resolve) => {
    setTimeout(() => resolve(compImport), 300);
  });

const Dashboard = lazy(() => delayed(import("../pages/dashboard/Dashboard")));
const Wealth = lazy(() => delayed(import("../pages/wealth/Wealth")));
const House = lazy(() => delayed(import("../pages/house/House")));
const Settings = lazy(() => delayed(import("../pages/settings/Settings")));
const ChangeLog = lazy(() => delayed(import("../pages/changeLog/ChangeLog")));

export const routes = [
  {
    path: RouteEnum.WEALTH,
    component: Wealth,
    title: "Wealth",
  },
  {
    path: RouteEnum.DASHBOARD,
    component: Dashboard,
    title: "Dashboard",
  },
  {
    path: RouteEnum.HOUSE,
    component: House,
    title: "House",
  },
  {
    path: RouteEnum.SETTINGS,
    component: Settings,
    title: "Settings",
  },
  {
    path: RouteEnum.CHANGELOG,
    component: ChangeLog,
    title: "ChangeLog",
  },
];
